export default function () {
  /* 表格列头 */
  return [{
    label: "序号",
    type: "index",
    width: 80
  },
  {
    label: "分类状态",
    prop: "status",
    slots: "status",
    width: 100
  },
  {
    label: "ID编码",
    prop: "id",
    width: 200,
  },
  {
    label: "分类名称",
    prop: "categoryName",
    width: 200,
  },
  {
    label: "分类主图",
    prop: "img_head",
    slots: "img_head",
  },
  {
    label: "分类等级",
    prop: "categoryLevel",
    slots: "categoryLevel",
    width: 200
  },

  {
    label: "所属父分类",
    prop: "parentID",
    slots: "parentID",
    width: 200
  },
  {
    label: "排序(越大排名越靠前)",
    prop: "sort",
    width: 200,
  },
  // { label: "是否设为首页推荐", prop: "recommend", slots: "recommend", width: 80 },
  // {
  //   label: "操作",
  //   prop: "operation",
  //   width: 150,
  //   slots: "operation",
  //   fixed: "right",
  // },
  ];
}